export default {
  idCard: "Cedula o pasaporte",
  login: " Iniciar sesión",
  password: "contraseña",
  remeberPassword: "No recuerdo mi contraseña",
  noAccount: "¿No tienes una cuenta?",
  Signup: "Registrarse"

}